<template>
  <div v-show="isLoaded" class="dRitualGold-container" v-observe-visibility="startAnimate">
    <div class="dRitualGold-title">
      <h2 class="title" :class="{animate: animate}">Ritual del Servido</h2>
    </div>
    <img class="dRitualGold-hoja" v-observe-visibility="startAnimate" :src="hoja" :class="{animate: animate}" alt="Hoja dorada">
    <div class="dFlex-container">
      <div class="dImagen Imagen-1" :class="{animate: animate}">
        <img class="" :src="paso1" alt="Paso 1">
      </div>
      <div class="dImagen Imagen-2" :class="{animate: animate}">
        <img class="" :src="paso2" alt="Paso 2">
      </div>
      <div class="dImagen Imagen-3" :class="{animate: animate}">
        <img class="" :src="paso3" alt="Paso 3">
      </div>
    </div>
  </div>
</template>

<script>
import hoja from '@/assets/gold-apple/Hoja_Dorada.png';
import paso1 from '@/assets/gold-apple/1GOLDAPPLE.png';
import paso2 from '@/assets/gold-apple/2GOLDAPPLE.png';
import paso3 from '@/assets/gold-apple/3GOLDAPPLE.png';
import { mapGetters } from "vuex";
import Bowser from "bowser";

export default {
  name: "D_RitualGold",
  data() {
    return {
      hoja,
      paso1,
      paso2,
      paso3,
      animate: false,
      isSafari: false,
    };
  },
   computed: {
    ...mapGetters(["isLoaded"]),
  },
  methods: {
    startAnimate(isVisible) {
      if(isVisible) {
        this.animate=true
      }  
    }
  },
  components: {},
  beforeMount() {
    const browser = Bowser.getParser(window.navigator.userAgent);
    if (browser.getBrowserName()=='Safari') {
      this.isSafari = true
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/variables.scss";
@import "~@/styles/GoldApple/D_RitualGold.scss";
</style>